import { getBaseUrl, getRequestWithTokenInformation } from "services/common";
import { RequestInit } from "atoms/models";

export const postClearOrder = async (cancelReason: string, cartCreated: boolean) => {
  const baseUrl = getBaseUrl();
  const relativeUrl = "ecommerce/route/clearOrder?cartCreated=" + (cartCreated ? cartCreated : false);
  const input = new URL(relativeUrl, baseUrl).href;
  const headers = new Headers();
  headers.append("Accept", "application/json");
  headers.append("Content-Type", "application/json");
  const bodyObject = { cancelReason };
  const body = JSON.stringify(bodyObject);
  const init: RequestInit = getRequestWithTokenInformation("POST", headers, body);
  const response: any = await window.fetch(input, init);

  if (response && 200 === response.status) {
    const decodedJson = await response.json();
    return decodedJson;
  } else if (response && (response.statusText || response["message"])) {
    return { message: response["message"] ? response["message"] : response.statusText };
  } else {
    return {};
  }
};
